import http from "./httpService";
// import apiUrl from "../config.json";
const apiUrl = require("../config.json").apiUrl;

export const getBoatHouse = () => {
  const apiEndPoint = `${apiUrl}/CheckddlBoatHouse`;
  return http.get(`${apiEndPoint}`);
};

export const getPinList = (data) => {
  const apiEndPoint = `${apiUrl}/CommonAPIMethod`;
  return http.post(`${apiEndPoint}`, data);
};
export const generatePin = (data) => {
  const apiEndPoint = `${apiUrl}/SavePinTransaction`;
  return http.post(`${apiEndPoint}`, data);
};
